

const GestaoMembros = () => {

    return (

        <div style={{ width: "100%", height: "100vh" }}>
        <iframe
            src="https://membros.hospitaissaudaveis.org/?token=8e317e3c-17b5-4b3c-b388-1a629dd24897"
            width="100%"
            height="100%"
            frameBorder="0"
            allowFullScreen
            title="Gestão Membros"
        />
        </div>

    )

}

export default GestaoMembros;